import React, { Component } from 'react';

class ImageWithLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      displayImage: false
    };
    this.spinnerRef = React.createRef();
  }

  componentDidMount() {
    const { isLazy } = this.props;
    if (isLazy) {
      const observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.setState({ displayImage: true });
            obs.disconnect();
          }
        }
      });
      observer.observe(this.spinnerRef.current);
    } else {
      this.setState({ displayImage: true });
    }
  }

    onLoad = () => {
      const { onImageLoad } = this.props;
      this.setState({
        showLoader: false
      }, onImageLoad());
    }

    render() {
      const { src, alt, background } = this.props;
      const { showLoader, displayImage } = this.state;
      return (
        <>
          {showLoader && (
          <div
            ref={this.spinnerRef}
            className="image-spinner"
            style={{ backgroundImage: `url(${background})` }}
          >
            <div className="bar1" />
            <div className="bar2" />
            <div className="bar3" />
            <div className="bar4" />
            <div className="bar5" />
            <div className="bar6" />
            <div className="bar7" />
            <div className="bar8" />
            <div className="bar9" />
            <div className="bar10" />
            <div className="bar11" />
            <div className="bar12" />
          </div>
          )}
          { displayImage && (
          <img
            src={src}
            alt={alt}
            className="cursor-pointer"
            onLoad={this.onLoad}
            style={{
              opacity: showLoader ? 0 : 1,
              maxHeight: showLoader ? 0 : null,
              maxWidth: showLoader ? 0 : null
            }}
          />
          ) }
        </>
      );
    }
}

ImageWithLoader.defaultProps = {
  isLazy: false
};

export default ImageWithLoader;
